import { Briefcase, LayoutDashboard, SlidersHorizontal, UserCheck } from 'lucide-react'
import type { TabKey } from '../types/hrmsAttendanceLeave.types'

interface AttendanceLeaveTabsProps {
  activeTab: TabKey
  onTabChange: (tab: TabKey) => void
}

const TABS: { key: TabKey; label: string; icon: React.ElementType }[] = [
  { key: 'overview', label: 'Overview', icon: LayoutDashboard },
  { key: 'attendance', label: 'Attendance', icon: UserCheck },
  { key: 'leave', label: 'Leave', icon: Briefcase },
  { key: 'configuration', label: 'Configuration', icon: SlidersHorizontal },
]

export function AttendanceLeaveTabs({ activeTab, onTabChange }: AttendanceLeaveTabsProps) {
  return (
    <div
      role="tablist"
      aria-label="Attendance & Leave Tabs"
      className="flex flex-nowrap items-center gap-1 border-b border-slate-200 pb-1 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden min-w-0"
    >
      {TABS.map((tab) => {
        const Icon = tab.icon
        const isActive = activeTab === tab.key

        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onTabChange(tab.key)}
            className={`flex shrink-0 whitespace-nowrap items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition-all duration-150 ${
              isActive
                ? 'bg-[#146971] text-white shadow-xs'
                : 'bg-transparent text-slate-600 hover:bg-slate-100 hover:text-slate-900'
            }`}
          >
            <Icon className="h-4 w-4" />
            <span>{tab.label}</span>
          </button>
        )
      })}
    </div>
  )
}
